import { I18n } from '@calendly/i18n';
import { AddIcon } from '@calendly/ui/components/icons';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { ProviderLogo } from 'components/integrations/elements/provider_logo';
import { ProviderIcon } from 'features/calendar_connections/provider_icon';
const containerCss = "c5o7ypg";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const iconsCss = "icgjhh5";
const Icons = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(iconsCss, props.className)} />;
});
const logoContainerCss = "l1d32act";
const LogoContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(logoContainerCss, props.className)} />;
});
export const FormHeader = () => <Container>
    <Icons>
      <LogoContainer>
        <ProviderLogo name="calendly" size="small" />
      </LogoContainer>
      <AddIcon size="large" />
      <ProviderIcon provider="icloud" size="xlarge" />
    </Icons>
    {I18n.t('publisher.calendar_settings.icloud.description')}
  </Container>;

require("./form_header.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./form_header.js");